// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"64789318b637450f446a","303":"fe9f4faa258e9901ec2b","495":"d1fee7e37273ce1bc33d"}[chunkId] + ".js";
};